import * as React from 'react'

const withWhen = (Component: any) => {
  const featureKey = 'RENDER'
  const WithWhenComponent: React.SFC<any> = ({
    config,
    when,
    ...restProps
  }: any) => {
    if (!when) {
      return <Component config={config} {...restProps} />
    }
    if (when) {
      const nextProps = {
        ...restProps,
        name: featureKey,
        config: {
          ...config,
          [featureKey]: when(config)
        }
      }
      return <Component {...nextProps} />
    }

    return null
  }

  WithWhenComponent.displayName = `WithWhen(${Component.displayName ||
    Component.name})`

  return WithWhenComponent
}

export default withWhen
